import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import matGroupService from '../../services/api/matGroupService';
import { AdminHeader, Paging } from '../../components';
import { storageService } from '../../services';
import { WebStorageNames } from '../../utils/Constants';
import { SchoolListMainWrapper, TableStyle } from '../../resources/styling/appStyle';
import AddSchoolInGroup from '../../components/common/AddSchoolInGroup';
import { toast } from 'react-toastify';
import { schoolService } from '../../services';
import { SchoolSurveyWrapper, SchoolSurveyInnerMain, SchoolSurveyInner, PaginationWrapper } from './MatStyle';

function MatSchools(props) {
  const [groupSchoolsList, setGroupSchoolsList] = useState([]);
  const [groupId] = useState(
    storageService.getItem(WebStorageNames.MatGroupId)
  );
  const [isAddSchoolOpen, setAddSchoolPopupOpen] = useState(false);
  const [schoolsList, setSchoolsList] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);

  useEffect(() => {
    matGroupService
      .getMatSchools(groupId)
      .then((response) => {
        const { success } = response;
        if (success) {
          setGroupSchoolsList(response.data);
        }
      })
      .catch((error) => {
        toast.error('Error loading schools.');
      });
    getSchoolsList();
  }, {});

  function getSchoolsList() {
    schoolService
      .GetSchoolsForMat()
      .then((response) => {
        const { success } = response;
        if (success) {
          setSchoolsList(response.data);
        }
      })
      .catch((error) => {
        toast.error('Error loading schools.');
      });
  }

  function addSchoolInGroup(schoolId) {
    matGroupService
      .addSchoolInGroup(schoolId, groupId)
      .then((response) => {
        const { success } = response;
        setAddSchoolPopupOpen(false);
        if (success) {
          setGroupSchoolsList(response.data);
          getSchoolsList();
        }
      })
      .catch((error) => {
        setAddSchoolPopupOpen(false);
        toast.error('Error adding school in group.');
      });
  }

  function onChangePage(pageOfItems) {
    setPageOfItems(pageOfItems);
  }
  return (
    <div>
      <AdminHeader />
      <SchoolSurveyWrapper>
        <SchoolSurveyInnerMain>
          <SchoolSurveyInner>
            <SchoolListMainWrapper>
              <h1 style={{margin: '0'}}>
                <span
                  className='back-btn'
                  onClick={() => props.history.push('/mat-accounts')}
                >
                  Back
                </span>
                <span className='heading'>Group Accounts List</span>
                <span
                  className='create-school'
                  onClick={() => setAddSchoolPopupOpen(true)}
                >
                  Add School
                </span>
              </h1>
              <TableStyle>
              <table>
                <thead>
                  <tr>
                    <th className='list-heading'>Name</th>
                    <th className='list-heading list-action'>Actions</th>
                  </tr>
                </thead>
              <tbody>
              {pageOfItems.map((item, i) => (
                <tr key={item.Id}>
                  <td>{item.Name ? item.Name : 'Not Provided'}</td>
                  <td></td>
                </tr>
              ))}
              </tbody>
              </table>
              </TableStyle>
              <PaginationWrapper>
                <Paging
                  items={groupSchoolsList}
                  onChangePage={(items) => onChangePage(items)}
                />
              </PaginationWrapper>
            </SchoolListMainWrapper>
          </SchoolSurveyInner>

          <AddSchoolInGroup
            isOpen={isAddSchoolOpen}
            onClose={() => {
              setAddSchoolPopupOpen(false);
            }}
            onOk={(schoolId) => addSchoolInGroup(schoolId)}
            schoolsList={schoolsList}
          />
        </SchoolSurveyInnerMain>
      </SchoolSurveyWrapper>
    </div>
  );
}

const mapStateToProps = ({ superAdmin: { SetSchoolsListFlag } }) => ({
  SetSchoolsListFlag,
});

export default connect(mapStateToProps, null)(withRouter(MatSchools));
